import BaseComponent from 'foundation/base-component';
import basketService from '../../../general/js/basket/basket-service';

export default class BasketCleanerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        basketService.cleanBasket(true);
        basketService.cleanBasket(false);
    }
}
